import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EditCustomerGroupPopup from "./EditCustomerGroupPopup";

const AddCustomerGroupPopup = ({
    extendedProps: {
        saveCustomerGroup,
    },
    onCancelChanges,
    open,
}) => {
    const handleClose = useCallback(() => {
        onCancelChanges();
    }, [onCancelChanges]);

    return (
        <EditCustomerGroupPopup
            open={open}
            save={saveCustomerGroup}
            onClose={handleClose}
        />
    );
};

AddCustomerGroupPopup.propTypes = {
    extendedProps: PropTypes.shape({
        saveCustomerGroup: PropTypes.func.isRequired,
    }).isRequired,
    onCancelChanges: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default AddCustomerGroupPopup;